var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTableEmail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sms"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5833 19.4792H6.41667C3.07083 19.4792 1.14583 17.5542 1.14583 14.2083V7.79167C1.14583 4.44583 3.07083 2.52083 6.41667 2.52083H15.5833C18.9292 2.52083 20.8542 4.44583 20.8542 7.79167V14.2083C20.8542 17.5542 18.9292 19.4792 15.5833 19.4792ZM6.41667 3.89583C3.795 3.89583 2.52083 5.17 2.52083 7.79167V14.2083C2.52083 16.83 3.795 18.1042 6.41667 18.1042H15.5833C18.205 18.1042 19.4792 16.83 19.4792 14.2083V7.79167C19.4792 5.17 18.205 3.89583 15.5833 3.89583H6.41667Z",
    fill: "#A2ABB4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.9998 11.7975C10.2298 11.7975 9.45063 11.5591 8.8548 11.0733L5.98563 8.78164C5.6923 8.54331 5.6373 8.11247 5.87563 7.81914C6.11397 7.5258 6.5448 7.47081 6.83814 7.70914L9.70729 10.0008C10.404 10.56 11.5865 10.56 12.2831 10.0008L15.1523 7.70914C15.4456 7.47081 15.8856 7.51664 16.1148 7.81914C16.3531 8.11247 16.3073 8.55247 16.0048 8.78164L13.1356 11.0733C12.549 11.5591 11.7698 11.7975 10.9998 11.7975Z",
    fill: "#A2ABB4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    opacity: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTableEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/table-email.d93ae882673f533d9d6aee8cfa6d178a.svg";